<template>
  <div style="text-align:center;margin-top:100px;">
    <el-button @click="refreshDbapi">刷新dbapi缓存</el-button>
  </div>
</template>

<script>
export default {
  methods: {
    refreshDbapi () {
      this.$http.get('/dbapi/reload').then(data => {
        this.$message({
          type: 'success',
          message: data.message
        })
      })
    }
  }
}
</script>
